<template>
  <Dialog v-model:visible="visible" modal :draggable="false" :closable="false" style="min-width: 720px">
    <template #header>
      <h2>Sync IAP</h2>
    </template>
    <p>
      Are you sure you want to sync this IAP based on the linked Pricing Template? This will discard any manual changes
      done to the IAP through Google Play Console.
    </p>
    <div :class="$style.formButtons">
      <Button type="button" label="Continue" :loading="loading" @click="onConfirm" />
      <Button type="button" label="Cancel" severity="secondary" :disabled="loading" @click="onCancel()" />
    </div>
  </Dialog>
</template>

<script setup>
import { Button, Dialog } from "primevue";
import { defineEmits, defineModel, ref } from "vue";
import useIAPs from "../hooks/useIAPs";
import useToast from "@/hooks/useToastNotification";

const { syncGooglePlayIAP } = useIAPs();
const { toastSuccess } = useToast();
const iap = defineModel();
const emit = defineEmits(["submit"]);

const visible = defineModel("visible");
const loading = ref(false);

const onConfirm = async () => {
  loading.value = true;
  const result = await syncGooglePlayIAP(iap.value.appId, iap.value.id);
  loading.value = false;
  if (result) {
    toastSuccess({
      detail: `Successfully synced IAP ${iap.value.name}!`,
      summary: "Success!",
      life: 5000,
    });
  }
  visible.value = false;
  emit("submit");
};

function onCancel() {
  visible.value = false;
}
</script>

<style module>
.formButtons {
  display: flex;
  gap: 8px;
  flex-direction: row-reverse;
}
</style>
